import {AxiosPromise} from 'axios';

import {backend} from '../../utils/_config/axios';

export default class GeoIpService {
    public getGeoIp(): AxiosPromise<{country: string}> {
        return backend().get('/geoip');
    }
}
